// Module
var code = "<md-button layout-align=\"center center\" class=\"md-primary pa0 pl4 pr4\" ng-click=\"$ctrl.editInvitationContent()\"> <md-tooltip>Edit</md-tooltip> <span>Edit</span> </md-button> ";
// Exports
module.exports = code;